import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {
  DefaultNotificationConfiguration,
  INotificationConfiguration,
  NotificationHeaderStyle,
  NotificationMessageType
} from "../class/notification.defs";
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";
import {TranslateService} from "@ngx-translate/core";

const NOTIFICATION_HEADER_TITLE = 'notification.header.';
const NOTIFICATION_CONTENT_TITLE = 'notification.content.';

@Component({
  selector: 'ispm-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class NotificationComponent implements OnInit {

  public notificationClass: string;
  public header: string = '';
  public content: string = '';
  public symbolClass: string = '';

  constructor(private store: Store<IgenomicsState>,
              private translateService: TranslateService) {
  }

  @Input('configuration')
  set configuration(configuration: INotificationConfiguration) {
    this.notificationClass = this.getNotificationClass(configuration);
  }

  ngOnInit() {
    this.notificationClass = this.getNotificationClass(DefaultNotificationConfiguration);
  }

  getHeader(): string {
    const key= NOTIFICATION_HEADER_TITLE + this.header;
    const content = this.translateService.instant(key);
    return content.toLowerCase() === key.toLowerCase()? '': content.toUpperCase();
  }

  getContent() : string {
    const key = NOTIFICATION_CONTENT_TITLE + this.content;
    const content = this.translateService.instant(key);
    return content.toLowerCase() === key.toLowerCase() ? '': content;
  }

  getNotificationClass(configuration: INotificationConfiguration) {
    if (configuration) {
      this.content = configuration.content;
      this.header = configuration.type ? configuration.type.toString():'';
      return configuration.type && configuration.style ? this.getByTypeAndStyle(configuration.type, configuration.style) : undefined;
    }
    return 'invisible';
  }

  private getByTypeAndStyle(type: NotificationMessageType, headerStyle: NotificationHeaderStyle) {
    // TODO: implement
    this.symbolClass = 'icon__exclamation sign';
    return 'global-banner';
  }
}
